import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { Place } from 'src/api/models'
import { AxiosError } from 'axios'
import { useQueryPaginator } from 'src/components/Table'
import { useForm, QuerySelectField, TextField } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import * as yup from 'yup'
import toast from 'react-hot-toast'
import { handleErrorMessage, Notification } from 'src/components/Notification'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface PlaceProps {
  facility: string
  parent: string
  name: string
}

const placeSchema = yup.object().shape({
  facility: yup.string().label('Facility'),
  parent: yup.string().label('Parent Place'),
  name: yup.string().label('Name'),
})

interface Props {
  open: boolean
  handleClose: () => void
  onSave?: () => void
  update?: boolean
  place?: Place
}

export const PlaceDialog = (props: Props) => {
  const { open, handleClose, onSave, update, place } = props
  const classes = useStyles()

  const facilityPaginator = useQueryPaginator('facility-list', skuit.sc.facilities.list)

  const placePaginator = useQueryPaginator('place-list', skuit.sc.places.list)

  const onSubmit = (data: PlaceProps) => {
    let func = skuit.sc.places.create
    let action = 'creat'
    if (update) {
      func = (data: PlaceProps) => skuit.sc.places.patch(place?.guid || '', data)
      action = 'updat'
      delete data.facility
      delete data.parent
    }
    func(data)
      .then((newPlace: Place) => {
        handleClose()
        if (onSave) {
          onSave()
        }
        toast.success(() => (
          <Notification
            message={`Successfully ${action}ed Place: ${newPlace.name}`}
            newObject={newPlace}
          />
        ))
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'Place')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, data: formData } = useForm(placeSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>{update ? 'Upd' : 'Cre'}ate Place</DialogTitle>
        <DialogContent>
          <QuerySelectField
            name="facility"
            label="Facility"
            paginator={facilityPaginator}
            defaultValue={place?.facility}
            disabled={update}
          />
          <QuerySelectField
            name="parent"
            label="Parent Place"
            paginator={placePaginator}
            defaultValue={place?.parent}
            disabled={update}
          />
          <TextField name="name" label="Name" defaultValue={place?.name} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
